import React from 'react'

export const decodeEntities = (encodedString) => {
    const textArea = document.createElement('textarea')
    textArea.innerHTML = encodedString
    return textArea.value
  }

 export const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
